<!-- =========================================================================================


CHOOSING TEAMS IS PART OF THE GAME


-->


  <!-- NOT HOST, WAITING FOR OTHERS-->

  <template>
  <div class="p-8 login-tabs-container relative w-full">
  <canvas ref="gameqr" class="ptawayqr"/>
  <h2 class="text-center mb-4" v-if="typeof gameState.numberOfResets !== 'undefined' && !gameStarted">Another Game!</h2>
  <gline class="w-full my-2 h-auto" v-if="typeof gameState.numberOfResets !== 'undefined' && !gameStarted" />
  <div v-if="!amItheHost && !gameStarted && typeof gameState.numberOfResets === 'undefined'">
    <h1 class="text-center mb-4 font-semibold" v-if="amIVerified" >You're In!</h1>
    <p class="text-center my-6 font-medium text-lg text-dark" v-if="nameOfHost">You're joining {{ nameOfHost }}'s game of...</p>
    <img class="block mx-auto w-24 h-auto mt-6" src="@/assets/images/game/teamtaboors.png"/>
  </div>

  <!--
  <paintable

  class="w-full"
  :alwaysOnTop="false"
  :active="true"
  :width="300"
  :height="400"
  :hide="false"
  :horizontalNavigation="true"
  :disableNavigation="true"
  :name="'my-screen'"
  :factor="1"
  :lineWidth="2"
  :lineWidthEraser="20"
  :useEraser="false"
  :color="'#000000'"
  ref="paintable"

  >

  ed

  </paintable>
  -->


  <div v-if="!amItheHost && !amIVerified && !gameStarted">
    <vs-divider/>
    <p class="text-center">Type your name to join!</p>
    <vs-input size="large" label="Your name" v-validate="'required|max:15'" name="first_name" class="w-full my-6" v-model="imAJoinerName" placeholder="Enter your first name..." />
    <span class="font-medium block text-danger text-lg mb-4 text-center" v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
    <vs-button color="primary" class="w-full" @click="verifyMe($event)">Join Game</vs-button>
  </div>

  <div v-if="!amItheHost && !amIVerified && gameStarted">
    <h1 class="text-center mt-20">🙃😬😑🙃😬😑🙃😬😑</h1>
    <h2 class="my-10 text-center">Game already started</h2>
    <p class="text-center">This game has already started. You'll need to ask the host to create a new game, or start your own.</p>
    <vs-button class="w-full my-4" href="https://games.remotesocial.io/play/startgame?game=typeitout">Start your own game</vs-button>
  </div>

  <div v-if="amItheHost && !gameStarted" class="w-full">
    <div v-if="!iAmChoosingTeams && (typeof gameState.numberOfResets === 'undefined')">
    <h6 class="text-center text-dark font-medium mt-4 mb-10">Great! 🙌👍</h6>
    <div v-if="gameState.gameType === 'video'">
      <h2 class="text-center text-2xl mb-4 leading-normal text-primary font-extrabold">Now, get on a video call with friends, and share the game link to their phones!</h2>        
      <div class="w-full text-center">
        <img src="@/assets/images/phonetopcsmall.png" class="w-full lg:px-10"/>
        <p class="text-center font-normal text-dark my-2 mx-auto max-w-sm leading-normal">Our games work best if everyone <span class="font-bold">video</span> chat on the <span class="font-bold">computer</span> and <span class="font-bold">play</span> from their <span class="font-bold">phones</span> 😀</p>
      </div>
    </div>
    <div v-else>
      <h2 class="text-center text-2xl mb-4 leading-normal">Now, let players scan this QR code, or share the game link to their phones!</h2>
      <div class="w-full text-center">
        <img v-if="qrImgSrc" :src="qrImgSrc" class="w-full lg:px-10"/>
      </div>
    </div>
    <vs-input label="Game Link" disabled :value="gameLink" class="w-full mt-6 disabledclearvalue" />
    <vs-button color="secondary" icon-after type="border" @click="copyLink" class="w-full my-2" :icon-pack="copyIcon ? 'feather' : ''" :icon="copyIcon ? copyIcon : ''">{{ copyText }}</vs-button>
    <vs-button class="w-full" @click="showQRPopup = true" type="border" color="secondary">Show QR Code <img v-if="qrImgSrc" :src="qrImgSrc" class="w-6 ml-1 float-right"/></vs-button>
    <vs-popup class="holamundo" title="Join Game QR Code" :active.sync="showQRPopup">
      <p class="my-0 text-center text-light font-normal max-w-xs mx-auto">(Share the below QR Code with other players so they can join the game)</p>
      <img v-if="qrImgSrc" :src="qrImgSrc" class="w-full lg:px-32 mx-auto block"/>
      <p class="mb-2 text-center text-primary font-bold text-xl">Scan with your phone to join!</p>
    </vs-popup>
    <vs-button color="#4FCE5D" icon-after :href="whatsAppLink" class="w-full my-2 sm:hidden" icon-pack="feather" icon="icon-share-2">Share link on Whatsapp</vs-button>
    <!-- HOST, START GAME -->
    <vs-button v-if="amItheHost && !gameStarted" size="large" :disabled="!(playersVerifiedAtStart.length >= numPlayersNeeded && gameState.currentTurn === false)" class="w-full mt-2" color="primary" @click="() => { iAmChoosingTeams = true; scrollToTop(); btnsKey = btnsKey + 1 }" icon-pack="feather" icon="icon-chevron-right" :key="btnsKey + 'sd3d'" icon-after>Start</vs-button>
    <p v-if="!gameStarted" class="my-2 text-center">You can continue when 4 or more players are in the game! Wait for everyone to join before you start continue.</p>
    </div>

    <div v-if="iAmChoosingTeams || gameState.numberOfResets > 0">
      <h2 class="text-center text-2xl mt-4 mb-4 leading-normal">Choose Teams</h2>
      <vs-divider class="my-8"/>
      <p class="text-center text-xl px-4 text-dark text-3xl">Now, <span class="font-bold">Drag and Drop👆</span> each player into a team! </p>
      <p class="text-center text-sm px-4 my-3">You can also rename teams or add more.</p>
      <div>
        <draggable :list="availablePlayers" :group="{name:'players'}" class="p-2 cursor-move overflow-auto mt-4">
          <vs-chip class="bg-primary pl-5 pr-8 py-3 font-bold" v-for="(player, index) in availablePlayers" :key="index"> {{ player.name }} </vs-chip>
        </draggable>
      </div>
      <div v-for="(team, i) in hostChosenTeams">
        <div class="py-2 px-2  bg-superlight rounded mt-4">
        <vx-input-group>
          <vs-input v-model="team.name" class="pt_input_team text-dark" />
          <template slot="append" v-if="(i + 1) > 2">
            <div class="append-text btn-addon">
              <vs-button type="border" :key="'sdf' + btnsKey" @click="btnsKey++; hostChosenTeams.pop()" color="secondary">X</vs-button>
            </div>
          </template>
        </vx-input-group>
        <draggable :list="team.players" :group="{name: 'players'}" class="cursor-move overflow-auto pt_whitechip py-base">
          <vs-chip v-for="(player, index) in team.players" :key="index"> {{ player.name }} </vs-chip>
        </draggable>
        <span class="text-sm block clear-both" v-if="team.players.length === 0">No one in this team yet. Drag players in here to add them!</span>
        </div>
      </div>
      <vs-button color="secondary" class="w-full mt-2" :key="btnsKey + 'sder'" @click="() => { hostChosenTeams.push({name: 'Team ' + String(hostChosenTeams.length+1), players: []}); btnsKey = btnsKey + 1 }" v-if="hostChosenTeams.length + 1 <= (playersVerifiedAtStart.length/2)" icon-pack="feather" icon="icon-plus">New team</vs-button>
      <vs-divider class="mb-6"/>
      <vs-button type="border" class="w-full mt-2" :key="btnsKey + 'sd'" color="secondary" @click="() => { iAmChoosingTeams = false; scrollToTop(); btnsKey = btnsKey + 1 }" icon-pack="feather" icon="icon-chevron-left">Back</vs-button>
      <vs-button size="large" class="w-full mt-2" color="primary" @click="startGame($event)" :disabled="!teamsGoodToGo">Start Game!</vs-button>
      <p v-if="!gameStarted" class="my-2 text-center">You can start when every player has a team, and every team has 2 or more players.</p>
      <p v-if="!gameStarted" class="my-2 text-center text-sm">(Minimum 4 players required)</p>
    </div>
  </div>


  <!-- HOST AND JOINER, SHOW WHOS JOINED -->
  <div class="my-4" v-if="!gameStarted">
    <div v-if="!(teams && !amItheHost)">
    <label class="vs-input--label">Your Crew</label>
    <div class="block py-4" v-if="!gameState.currentTurn">
      <p class="text-dark font-medium text-l">
        <span class="block my-2" v-for="(player,i) in playersVerifiedAtStart">
            {{ (i === 0 ? '✔️' : '✔️') + (player.name === myName ? myName + ' (You)' : player.name) }}
            <vs-button v-if="amItheHost && player.uid !== myUID" :key="JSON.stringify(playerUIDToNames) + String (player.uid)" size="small" type="border" color="primary" class="inline-block ml-2" @click="removeFromPUTN($event,player.uid)" icon-pack="feather" icon="CopyIcon"> Remove</vs-button>
          </span>
      </p>
    </div>
    </div>
    <label v-if="teams && !amItheHost" class="vs-input--label">Teams</label>
    <p v-if="teams && !amItheHost" class="text-center text-sm">{{ nameOfHost }} is choosing teams...</p>
    <div v-if="teams && !amItheHost" v-for="(team, i) in teams">
      <div class="py-4 px-3  bg-superlight rounded my-4">
      <h4 class="mt-1 mb-3 text-lg">{{ team.name }}</h4>
      <div class="overflow-auto pt_whitechip">
        <vs-chip v-for="(player, index) in team.players"> {{ player.name }} </vs-chip>
      </div>
      <span class="text-sm block clear-both" v-if="team.players.length === 0">No one in this team yet.</span>
      </div>
    </div>
    <p v-if="!gameStarted && !amItheHost && amIVerified && (typeof gameState.numberOfResets === 'undefined')" class="my-2 text-center">Waiting for everyone... {{ nameOfHost}} can start the game when all players have joined and teams chosen.</p>
    <div class="text-dark">
      <vs-divider/>
      <ul class="font-medium">
        <li class="my-3" v-if="!amItheHost">☝️ If you lose the game, <span class="font-bold">enter the way you came</span>.</li>
        <li class="my-3" v-if="amItheHost">☝️ If you lose the game, open the <span class="font-bold">game link</span> in this <span class="font-bold">same browser</span> you hosted from.</li>
        <li>☝️ If you get stuck, <span class="font-bold">refresh your browser.</span></li>
      </ul>
    </div>
    <div v-if="amItheHost">

      <!--
      <vs-divider/>
      <div class="text-center mt-8">
        <svg class="inline-block opacity-75 h-16 w-auto" width="138px" height="92px" viewBox="0 0 138 92" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Group-6" fill="#444444" fill-rule="nonzero">
                <g id="laptop">
                    <path d="M134.861509,74.6940468 L126.253322,74.6940468 L126.253322,11.5672515 C126.253322,5.23727485 121.105895,0.0895789474 114.775649,0.0895789474 L22.955076,0.0895789474 C16.6250994,0.0895789474 11.4774035,5.23700585 11.4774035,11.5672515 L11.4774035,74.6940468 L2.86921637,74.6940468 C1.2834269,74.6940468 0,75.9772047 0,77.5632632 L0,80.4327485 C0,86.7627251 5.1474269,91.9104211 11.4776725,91.9104211 L126.253591,91.9104211 C132.583567,91.9104211 137.730994,86.7627251 137.730994,80.4327485 L137.730994,77.5632632 C137.730994,75.9772047 136.447567,74.6940468 134.861509,74.6940468 Z M17.2163743,11.5672515 C17.2163743,8.40374269 19.7915673,5.82854971 22.955076,5.82854971 L114.775649,5.82854971 C117.939158,5.82854971 120.514351,8.40374269 120.514351,11.5672515 L120.514351,74.6940468 L83.212386,74.6940468 L54.5186082,74.6940468 L17.2163743,74.6940468 L17.2163743,11.5672515 Z M126.253322,86.1714503 L11.4776725,86.1714503 C8.31416374,86.1714503 5.73897076,83.5962573 5.73897076,80.4327485 L14.3471579,80.4327485 L53.3304094,80.4327485 L55.3592515,82.4615906 C55.8972632,82.9996023 56.625731,83.3022339 57.3880936,83.3022339 L80.3431696,83.3022339 C81.1052632,83.3022339 81.834,82.9996023 82.3720117,82.4615906 L84.4005848,80.4327485 L123.384105,80.4327485 L131.992292,80.4327485 C131.992292,83.5962573 129.417099,86.1714503 126.253322,86.1714503 Z" id="Shape"></path>
                </g>
                <path d="M83.3560529,35.1749746 L74.5666328,33.9053917 L70.6602238,25.8972533 C70.3672431,25.311292 69.6836216,25.0183113 69,25.0183113 C68.3163784,24.9206511 67.6327569,25.2136317 67.3397762,25.8972533 L63.4333672,33.9053917 L54.6439471,35.1749746 C53.9603255,35.2726348 53.4720244,35.7609359 53.276704,36.3468973 C53.0813835,36.9328586 53.1790437,37.5188199 53.6673449,38.0071211 L60.0152594,44.2573754 L58.5503561,53.0467955 C58.4526958,53.7304171 58.7456765,54.3163784 59.2339776,54.7070193 C59.5269583,54.9023398 59.819939,55 60.2105799,55 C60.5035605,55 60.7965412,54.9023398 60.9918616,54.8046796 L68.9023398,50.7029502 L69,50.8006104 L69.0976602,50.7029502 L77.0081384,54.8046796 C77.2034588,54.9023398 77.4964395,55 77.7894201,55 C78.180061,55 78.4730417,54.9023398 78.7660224,54.7070193 C79.2543235,54.3163784 79.5473042,53.7304171 79.4496439,53.0467955 L77.9847406,44.2573754 L84.3326551,38.0071211 C84.8209563,37.5188199 84.9186165,36.9328586 84.723296,36.3468973 C84.5279756,35.7609359 84.0396745,35.2726348 83.3560529,35.1749746 Z M74.8596134,42.4018311 C74.4689725,42.792472 74.2736521,43.3784334 74.3713123,43.8667345 L75.4455748,50.214649 L69.7812818,47.1871821 C69.5859613,47.0895219 69.2929807,46.9918616 69,46.9918616 C68.7070193,46.9918616 68.4140387,47.0895219 68.2187182,47.1871821 L62.5544252,50.214649 L63.6286877,43.8667345 C63.7263479,43.3784334 63.5310275,42.792472 63.1403866,42.4018311 L58.5503561,37.9094608 L64.8982706,37.0305188 C65.4842319,37.0305188 65.9725331,36.6398779 66.1678535,36.1515768 L69,30.3896236 L71.8321465,36.1515768 C72.0274669,36.6398779 72.5157681,37.0305188 73.1017294,37.0305188 L79.4496439,37.9094608 L74.8596134,42.4018311 Z" id="Shape"></path>
            </g>
        </g>
    </svg>
        <svg class="inline-block opacity-75 h-20 w-auto ml-2" width="69px" height="92px" viewBox="0 0 69 92" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="smartphone" fill-rule="nonzero">
                <path d="M33.0008672,70.4375 C32.5282891,70.4375 32.0646953,70.6297656 31.7304766,70.9639844 C31.3962578,71.2982031 31.2039922,71.7617969 31.2039922,72.234375 C31.2039922,72.7069531 31.3962578,73.1705469 31.7304766,73.5047656 C32.0646953,73.8389844 32.5282891,74.03125 33.0008672,74.03125 C33.4734453,74.03125 33.9370391,73.8389844 34.2712578,73.5047656 C34.6054766,73.1705469 34.7977422,72.7069531 34.7977422,72.234375 C34.7977422,71.7617969 34.6054766,71.2982031 34.2712578,70.9639844 C33.9370391,70.6297656 33.4734453,70.4375 33.0008672,70.4375 L33.0008672,70.4375 Z" id="XMLID_307_" fill="#444444"></path>
                <path d="M66.5984766,57.5866094 C65.8524141,56.8405469 64.9579297,56.2973516 63.9824062,55.9809219 L66.1747734,53.7885547 C67.4176719,52.5456563 68.1021016,50.8930703 68.1021016,49.1353672 C68.1021016,47.3776641 67.4174922,45.7250781 66.1745937,44.4821797 C65.4132578,43.7208438 64.5096094,43.1873516 63.549,42.87775 L65.8858359,40.5409141 C68.4514141,37.9751562 68.4514141,33.8004766 65.8858359,31.2345391 C65.1250391,30.4737422 64.2221094,29.9404297 63.2622188,29.6308281 C65.7587969,27.0596797 65.7372344,22.9380078 63.1946563,20.3954297 C62.2726797,19.4734531 61.142625,18.8846172 59.9543516,18.6253281 L59.9543516,9.703125 C59.9543516,4.35275 55.6016016,0 50.2512266,0 L15.7512266,0 C10.4008516,0 6.04810156,4.35275 6.04810156,9.703125 L6.04810156,30.9084062 C4.75650781,30.4426562 3.36536719,30.1875 1.91528906,30.1875 C0.922875,30.1875 0.118414062,30.9919609 0.118414062,31.984375 L0.118414062,73.6979297 C0.118414062,80.1228359 2.37025781,86.3906953 6.45886719,91.3466562 C6.81428906,91.7773672 7.32801562,92.0001797 7.84605469,92.0001797 C8.24855469,92.0001797 8.65375,91.8654141 8.98850781,91.5892344 C9.75397656,90.9576328 9.8626875,89.8252422 9.23108594,89.0595938 C5.67219531,84.7458359 3.71216406,79.2901641 3.71216406,73.69775 L3.71216406,33.9695625 C7.60850781,34.7984609 10.5402891,38.2664297 10.5402891,42.40625 L10.5402891,54.984375 C10.5402891,55.6156172 10.8714531,56.2005 11.4126719,56.5251953 C18.6330547,60.8574609 23.1184141,68.7795234 23.1184141,77.1998594 L23.1184141,79.4202578 C23.1184141,80.4144687 23.922875,81.2189297 24.9152891,81.2189297 L50.2512266,81.2189297 C52.2931953,81.2189297 54.2011172,80.5767266 55.7760781,79.4806328 C54.8010938,83.1336797 52.6466406,86.4395703 49.6149531,88.7812578 C48.8295391,89.3878828 48.6847109,90.5163203 49.2913359,91.3017344 C49.6455,91.7601172 50.1770156,92.0001797 50.7146406,92.0001797 C51.0980938,92.0001797 51.4847813,91.8778125 51.8118125,91.6253516 C56.9102656,87.6869609 59.9541719,81.4895391 59.9541719,75.0472031 L59.9541719,73.2221172 C60.4456172,72.9373125 60.9038203,72.5878203 61.3162031,72.1754375 L66.5984766,66.8931641 C69.1640547,64.3272266 69.1640547,60.1525469 66.5984766,57.5866094 Z M64.5081719,49.1355469 C64.5081719,49.9333594 64.1974922,50.683375 63.6334531,51.2474141 L57.6087109,57.2719766 C57.0446719,57.8361953 56.2946563,58.146875 55.4968438,58.146875 C54.6992109,58.146875 53.9490156,57.8361953 53.3849766,57.2719766 C52.8207578,56.7079375 52.5100781,55.9579219 52.5100781,55.1601094 C52.5100781,54.3622969 52.8207578,53.6122813 53.3847969,53.0482422 L59.4095391,47.0236797 C59.9917266,46.4413125 60.7566563,46.1502188 61.5214062,46.1502188 C62.2861562,46.1502188 63.0510859,46.4413125 63.6332734,47.0236797 C64.1974922,47.5875391 64.5081719,48.3377344 64.5081719,49.1355469 L64.5081719,49.1355469 Z M63.3443359,38.0001328 L55.8790391,45.4654297 C54.7144844,46.6299844 52.8195,46.6299844 51.655125,45.4654297 C50.4905703,44.300875 50.4905703,42.4058906 51.655125,41.2413359 L59.1206016,33.7760391 C59.7029688,33.1936719 60.4675391,32.9025781 61.2324688,32.9025781 C61.9972188,32.9025781 62.7623281,33.1938516 63.3443359,33.7758594 C64.5088906,34.9405938 64.5088906,36.8355781 63.3443359,38.0001328 L63.3443359,38.0001328 Z M60.6533359,27.1608438 L53.1878594,34.6263203 C52.6238203,35.1905391 51.8738047,35.5012188 51.0759922,35.5012188 C50.2783594,35.5012188 49.5281641,35.1905391 48.964125,34.6263203 C47.7995703,33.4619453 47.7995703,31.5669609 48.964125,30.4024063 L56.4296016,22.9371094 C57.0117891,22.3547422 57.7767188,22.0636484 58.5414688,22.0636484 C59.3062188,22.0636484 60.0711484,22.3547422 60.6533359,22.9371094 C61.8177109,24.1014844 61.8177109,25.9962891 60.6533359,27.1608438 L60.6533359,27.1608438 Z M14.1336797,53.9894453 L14.1336797,42.40625 C14.1336797,38.5975938 12.3813672,35.1912578 9.64149219,32.9487578 L9.64149219,11.5 L24.9149297,11.5 C25.9073438,11.5 26.7118047,10.6955391 26.7118047,9.703125 C26.7118047,8.71071094 25.9073438,7.90625 24.9149297,7.90625 L9.9115625,7.90625 C10.6808047,5.41182813 13.0073984,3.59375 15.7508672,3.59375 L50.2508672,3.59375 C52.9945156,3.59375 55.3211094,5.41182813 56.0901719,7.90625 L41.086625,7.90625 C40.0942109,7.90625 39.28975,8.71071094 39.28975,9.703125 C39.28975,10.6955391 40.0942109,11.5 41.086625,11.5 L56.3600625,11.5 L56.3600625,18.8409531 C55.4565938,19.1566641 54.6088281,19.6748828 53.8879219,20.3956094 L46.4224453,27.8610859 C46.2591094,28.0244219 46.106375,28.1945859 45.9637031,28.3701406 C45.3279688,27.7960391 44.4904453,27.4636172 43.5681094,27.4636172 L38.0829688,27.4636172 L36.406125,22.2763984 C35.9195313,20.7709766 34.5828359,19.7981484 33.0005078,19.7981484 C31.4181797,19.7981484 30.0814844,20.7709766 29.5948906,22.2763984 L27.9180469,27.4636172 L22.4329063,27.4636172 C20.8514766,27.4636172 19.5147813,28.4359063 19.0276484,29.9404297 C18.5406953,31.4451328 19.0538828,33.0161406 20.3354141,33.9429688 L24.77675,37.1548828 L23.0779844,42.3444375 C22.5854609,43.8493203 23.094875,45.4228437 24.3758672,46.353625 C25.0151953,46.8181172 25.7474219,47.0502734 26.4796484,47.0502734 C27.2143906,47.0502734 27.9491328,46.8165 28.5897188,46.3489531 L33.0003281,43.1296719 L37.4109375,46.3489531 C38.6897734,47.2824297 40.3439766,47.2840469 41.6247891,46.353625 C42.9057813,45.4228437 43.4151953,43.8491406 42.9226719,42.3444375 L41.2239063,37.1548828 L44.8214297,34.5531875 C45.1315703,35.5094844 45.6638047,36.4088203 46.4220859,37.1671016 C47.1694063,37.9144219 48.0653281,38.4579766 49.0426484,38.7742266 C46.5494844,41.3455547 46.5719453,45.4647109 49.1134453,48.0062109 C49.8747813,48.7675469 50.7784297,49.3010391 51.7390391,49.6106406 L50.8432969,50.5063828 C49.6003984,51.7492812 48.9159688,53.4018672 48.9159688,55.1595703 C48.9159688,56.9172734 49.6005781,58.5698594 50.8432969,59.8127578 C51.5895391,60.5588203 52.4838438,61.1020156 53.4593672,61.4184453 L52.0092891,62.8685234 C51.8865625,62.99125 51.7708438,63.1191875 51.6590781,63.2496406 L22.9399844,63.2496406 C20.7675625,59.5238203 17.7432422,56.3429922 14.1336797,53.9894453 L14.1336797,53.9894453 Z M37.4010547,37.0267656 L39.4936953,43.4198672 L34.060125,39.4539844 C33.4288828,38.9934453 32.5726719,38.9934453 31.9414297,39.4539844 L26.5078594,43.4198672 L28.6005,37.0267656 C28.8436172,36.2842969 28.5789375,35.4695938 27.9457188,35.01175 L22.4780078,31.0575469 L29.2258125,31.0575469 C30.0052969,31.0575469 30.6958359,30.5549609 30.9355391,29.8133906 L33.0006875,23.4249609 L35.0658359,29.8133906 C35.3055391,30.5549609 35.9960781,31.0575469 36.7755625,31.0575469 L43.5233672,31.0575469 L38.0556563,35.01175 C37.4226172,35.4695938 37.1579375,36.2842969 37.4010547,37.0267656 L37.4010547,37.0267656 Z M50.2508672,77.625 L26.7118047,77.625 L26.7118047,77.1996797 C26.7118047,73.6472578 26.0223438,70.1253828 24.7009219,66.84375 L50.1171797,66.84375 C50.0943594,67.0676406 50.0823203,67.2940469 50.0823203,67.5220703 C50.0823203,69.2797734 50.7669297,70.9323594 52.0096484,72.1752578 C53.0489609,73.2145703 54.3750547,73.861625 55.8091406,74.0463438 C54.8402656,76.1614453 52.6985703,77.625 50.2508672,77.625 L50.2508672,77.625 Z M64.0571563,64.3516641 L58.7748828,69.6341172 C58.2108438,70.1983359 57.4608281,70.5090156 56.6630156,70.5090156 C55.8652031,70.5090156 55.1151875,70.1983359 54.5511484,69.6341172 C53.9869297,69.0700781 53.67625,68.3200625 53.67625,67.52225 C53.67625,66.7244375 53.9869297,65.9744219 54.5511484,65.4103828 L59.8334219,60.1281094 C60.3974609,59.5638906 61.1474766,59.2532109 61.9452891,59.2532109 C62.7431016,59.2532109 63.4931172,59.5638906 64.0571563,60.1279297 C65.2217109,61.2923047 65.2217109,63.1872891 64.0571563,64.3516641 L64.0571563,64.3516641 Z" id="XMLID_310_" fill="#444444"></path>
                <path d="M29.5639844,54.9629922 L36.43775,54.9629922 C37.4301641,54.9629922 38.234625,54.1585313 38.234625,53.1661172 C38.234625,52.1737031 37.4301641,51.3692422 36.43775,51.3692422 L29.5639844,51.3692422 C28.5715703,51.3692422 27.7671094,52.1737031 27.7671094,53.1661172 C27.7671094,54.1585313 28.5715703,54.9629922 29.5639844,54.9629922 Z" id="XMLID_317_" fill="#444440"></path>
                <path d="M33.0008672,11.5 C33.4734453,11.5 33.9370391,11.3077344 34.2712578,10.9735156 C34.6054766,10.6392969 34.7977422,10.1757031 34.7977422,9.703125 C34.7977422,9.23054687 34.6054766,8.76695313 34.2712578,8.43273438 C33.9370391,8.09851562 33.4734453,7.90625 33.0008672,7.90625 C32.5282891,7.90625 32.0646953,8.09851562 31.7304766,8.43273438 C31.3962578,8.76695313 31.2039922,9.23054687 31.2039922,9.703125 C31.2039922,10.1757031 31.3962578,10.6392969 31.7304766,10.9735156 C32.0646953,11.3077344 32.5282891,11.5 33.0008672,11.5 L33.0008672,11.5 Z" id="XMLID_318_" fill="#444444"></path>
            </g>
        </g>
    </svg>
      </div>
      <p class="text-center max-w-sm mx-auto text-light">Players can join our games on any modern computer, tablet or smartphone web browser!</p>
      <p class="text-center mt-8 mb-2">Video call with your favorite app</p><img class="w-40 mx-auto" src="@/assets/images/logo/videologos.png" />
      -->
    </div>
  </div>


  <div v-if="gameStarted && amIVerified">

    <div v-if="screenMessageLocal">

      <div v-if="screenMessageLocal.context === 'turnover'" >
        <div>
          <p v-for="(word, i) in screenMessageLocal.magicWords" class="inline-block pr-2">{{ word }}{{ i ===  screenMessageLocal.magicWords.length - 1 ? '':', '}}</p>
        <vs-divider/>
        </div>
        <p class="text-center mt-6 mb-3 text-4xl" v-if="screenMessageLocal.pointsGained > 0 && screenMessageLocal.pointsGained < 5">🙌</p>
        <p class="text-center mt-6 mb-3 text-4xl" v-if="screenMessageLocal.pointsGained > 4">🙌🙌🙌</p>
        <h2 class="text-center my-10">+{{ screenMessageLocal.pointsGained === 0 ? 'No' : screenMessageLocal.pointsGained }} point{{ screenMessageLocal.pointsGained === 1 ? '' :'s' }} for {{ teams[screenMessageLocal.teamIndex].name }}!</h2>
        <p class="mt-6 mb-8 text-center text-2xl font-medium text-dark" v-if="screenMessageLocal.pointsGained === 0">☝️ Remember to seperate your guesses with <span class="font-bold">commas!</span></p>
        <label class="vs-input--label block mb-4" v-if="screenMessageLocal.wordsGuessed.length !== 0">Guesses</label>
        <div v-for="guess in screenMessageLocal.wordsGuessed">
            <p class="inline-block float-right text-success text-sm" v-if="guess.extraForSpelling">+1 for Spelling👌</p>
            <p class="inline-block float-right text-sm" v-if="!guess.extraForSpelling && guess.correct">"{{ guess.correctFor }}"</p>
            <h5 style="max-width: 200px; word-break: break-word;" :class="{'text-danger' : !guess.correct, 'text-success' : guess.correct  }">{{ guess.guess }} <span v-if="guess.correct">✅</span><span v-else>❌</span></h5>
          <vs-divider/>
        </div>
      </div>
      <div v-if="screenMessageLocal.context === 'win'" class="text-center" >
        <h2 class="mt-10">🏆 😁 🥳 🏆</h2>
        <h2 class="my-2 mb-4 font-bold text-4xl">{{ screenMessageLocal.teamName }} wins!!</h2>
        <h2 class="mb-0">🏆 🥳 😁 🏆</h2>
        <h4 class="my-10">Congratulations!</h4>
        <p class="my-4 " v-if="!gameOver">Other teams can continue playing for 2nd.. 3rd.. places etc.</p>
        <div class="my-4 text-left">
          <div v-for="guess in screenMessageLocal.wordsGuessed">
            <p class="inline-block float-right text-success" v-if="guess.extraForSpelling">+1 for Spelling👌</p>
            <p class="inline-block float-right" v-if="!guess.extraForSpelling && guess.correct">"{{ guess.correctFor }}"</p>
            <h4 :class="{'text-danger' : !guess.correct, 'text-success' : guess.correct  }">{{ guess.guess }} <span v-if="guess.correct">✅</span><span v-else>❌</span></h4>
          <vs-divider/>
          </div>
        </div>
      </div>
      <div v-if="screenMessageLocal.context === 'leave'" class="text-center" >
        <h2 class="mt-10">💩☝️💩☝️💩</h2>
        <h2 class="my-10 font-medium text-2xl">{{ screenMessageLocal.name }} has been removed from the game.</h2>
        <h2 v-if="screenMessageLocal.newHost" class="my-10 font-medium text-2xl">{{ gameState.hostName }} is now the new host.</h2>
      </div>
      <div v-if="screenMessageLocal.context === 'done'" >

        <h2 class="text-center my-10 font-bold text-4xl">{{ screenMessageLocal.teamName }} is {{ getOrdinal(screenMessageLocal.place) }}!</h2>

      </div>
      <div v-if="gameOver">
        <label class="vs-input--label block mt-6 mb-4" >Game Over</label>
        <div class="mt-3" v-for="team in teamsDone">
          <p class="float-right inline-block">{{ team.place === 0 ? '1st🏆' : getOrdinal(team.place) }}</p>
          <h4 class="mb-2">{{ team.name }}</h4>
          <vs-divider/>
        </div>
        <div class="mt-3" v-for="team in teams">
          <p class="float-right inline-block">{{ getOrdinal(teamsDone.length + 1) }}</p>
          <h4 class="mb-2">{{ team.name }}</h4>
          <vs-divider/>
        </div>
      </div>
    </div>
    <vs-button v-if="screenMessageLocal && !gameOver" size="large" icon-pack="feather" icon="icon-chevron-right" icon-after type="border" class="w-full my-4" @click="() => {screenMessageLocal = false; scrollToTop()}">Continue</vs-button>
    <div v-if="gameOver">
      <vs-button v-if="amItheHost" size="large" class="w-full my-4" @click="playAgain">Play Again</vs-button>
      <p v-else class="my-2 text-center">Keen for another round? The host can start another by selecting "Play Again".</p>
    </div>
    <div v-if="!screenMessageLocal && !gameOver">


      <!-- MY TEAM TURN -->
      <div v-if="myTeamsTurn">
        <div v-if="!peopleHaveToGuessWords">
        <h4 class="text-center my-4 font-medium text-sm">{{ teams[currentTurn.teamIndex].name }}'s Turn</h4>
        <h2 class="text-center text-4xl mt-5">🙋‍</h2>
        <h4 class="text-center mt-2 mb-4 text-lg font-bold" v-if="currentTurn.explainer.uid === myUID">YOUR Team's Turn!</h4>
        <h4 class="text-center mt-2 mb-4 text-2xl font-bold" v-if="currentTurn.explainer.uid !== myUID" :class="{'font-bold': currentTurn.explainer.uid === myUID}">YOUR Team's Turn!</h4>
        <vs-divider class="mt-4"/>
        <p class="text-dark text-center px-4 my-6 text-2xl font-bold" v-if="currentTurn.explainer.uid === myUID">You are the describer!</p>
        <p class="text-dark text-center px-4 my-6 text-2xl" v-if="currentTurn.explainer.uid !== myUID"><span class="font-bold text-3xl">{{ currentTurn.explainer.name }}</span> is the describer!</p>
        <vs-divider/>
        </div>
        <div v-if="peopleHaveToGuessWords && secondsLeft !== false">
          <div v-if="secondsLeft !== 0">
          <div v-if="currentTurn.explainer.uid === myUID">
            <h2 class="mx-5 text-center font-semibold text-lg" v-if="secondsLeft !== 0">GO! 🏁</h2>
              <vs-divider/>
              <div class="">
                <div :class="{'text-light_pt': word.spellingCorrect, 'font-medium_pt': word.spellingCorrect}" class="mr-4 my-2 block relative text-dark text-xl font-bold"  v-for="word in peopleHaveToGuessWords">{{ word.text }}<span class="text-sm font-medium">{{ word.correct ? ' ✅':''}}{{ word.spellingCorrect ? '🔤':''}}</span></div>
              </div>
              <vs-divider/>
              <div class="overflow-auto text-dark">
                  <div class="float-left w-1/2 pr-4" v-if="Object.keys(currentWriteBoard).length > 0">
                      <div class="mb-4" v-for="(player, i) in Object.keys(currentWriteBoard)" v-if="currentWriteBoard[player].trim() !== ''">
                        <label class="vs-input--label block mt-3 text-dark font-bold">{{ playerUIDToNames[player] }}</label>
                        <span class="text-dark" style="max-width: 120px; word-break: break-word;">{{ currentWriteBoard[player] }}</span>
                      </div>
                  </div>
              </div>
              <p class="text-center relative text-dark" style="top: 1.65rem; z-index: 2000;"><span>{{ secondsLeft  ?  (secondsLeft > timePerTurnMS/1000 ? timePerTurnMS/1000 : secondsLeft ) : 'Time\'s Up!' }}</span></p>
              <vs-progress :height="25" :percent="Math.round(secondsLeft / (timePerTurnMS / 1000) * 100)" color="primary"></vs-progress>
          </div>
          <div v-else>
            <h2 class="mb-2 mt-8 text-center font-extrabold text-4xl" v-if="secondsLeft !== 0">GO! 🏁</h2>
            <p class="text-center relative text-dark" style="top: 1.65rem; z-index: 2000;"><span>{{ secondsLeft  ?  (secondsLeft > timePerTurnMS/1000 ? timePerTurnMS/1000 : secondsLeft ) : 'Time\'s Up!' }}</span></p>
            <vs-progress :height="25" :percent="Math.round(secondsLeft / (timePerTurnMS / 1000) * 100)" color="primary"></vs-progress>
            <label class="vs-input--label text-xl font-bold block my-2 text-center">Type Your Guesses:</label>
            <p class="text-center text-sm">Seperate each guess with a <span class="font-bold">comma</span>.</p>
            <vs-textarea cols="60" style="white-space:pre-wrap;" rows="10" placeholder="i.e. Elvis Presley, Apple, Venus Williams" v-model="myGuesses" class="w-full pt_textarea" maxlength="200" />
            <div class="inline-block relative pr-6 text-dark font-medium" v-if="words.correct" v-for="(words,i) in peopleHaveToGuessWords">
              <span v-if="words.spellingCorrect">{{ words.text }}✅🔤</span>
              <span v-if="!words.spellingCorrect && words.correct && myGuessesContainAnyOf(words.original)">{{ myGuessesContainAnyOf(words.original) }}✅</span>
            </div>
          </div>
          </div>
        </div>

        <div v-if="guessersNeedToSayReady">
          <div v-if="currentTurn.explainer.uid === myUID">
            <div v-if="guessersReady.indexOf(myUID) === -1">
              <p class="text-center my-8 px-6 text-dark text-lg">When you select "Go!" you will get<span class="font-bold"> 5 words</span> and have <span class="font-bold">40 seconds</span> to describe them <span class="font-bold">to <span v-for="(player,i) in guessersNeedToSayReady">{{ player.name }}{{ guessersNeedToSayReady.length > 1 ? ( i === guessersNeedToSayReady.length - 1  ? '' : ( i === guessersNeedToSayReady.length - 2 ? ' and ' : ', ')) : '' }}</span>!</span></p>
              <vs-button class="w-full" size="large" @click="sayImReady($event)">Go!</vs-button>
            </div>
          </div>
          <div v-else>
            <p class="text-center my-12 text-lg px-6"><p class="text-center my-8 text-lg px-6 text-dark text-lg">When {{ playerUIDToNames[currentTurn.explainer.uid] }} selects "Go!" they will <span class="font-bold">see 5 words</span> and have <span class="font-bold">40 seconds</span> to describe them to <span v-for="(player,i) in guessersNeedToSayReady">{{ player.name }}{{ guessersNeedToSayReady.length > 1 ? ( i === guessersNeedToSayReady.length - 1  ? '' : ( i === guessersNeedToSayReady.length - 2 ? ' and ' : ', ')) : '' }}</span>!</p>
          </div>
        </div>
      </div>


      <!-- OTHER TEAM TURN

      <div class="float-left w-1/2 pr-3">
        <label class="vs-input--label">Taboo Words</label>
        <p class="my-4 text-xl font-bold" v-for="words in peopleHaveToGuessWords">{{ words }}</p>
      </div>

      -->
      <div v-if="!myTeamsTurn">
        <h2 class="text-center text-4xl mt-5">🙅‍</h2>
        <h4 class="text-center my-4 font-bold text-2xl">{{ teams[currentTurn.teamIndex].name }}'s Turn</h4>
        <vs-divider class="mt-4"/>
        <p class="text-dark text-center px-4 my-6 text-2xl" v-if="currentTurn.explainer.uid !== myUID"><span class="font-bold text-3xl">{{ currentTurn.explainer.name }}</span> is the describer!</p>
        <vs-divider/>

        <div v-if="peopleHaveToGuessWords && secondsLeft !== false">
          <h2 class="mt-8 mb-4 text-center font-extrabold text-xl" v-if="secondsLeft !== 0">Timer Started! ⌛</h2>
          <p class="text-center relative text-dark" style="top: 1.65rem; z-index: 2000;"><span>{{ secondsLeft  ?  (secondsLeft > timePerTurnMS/1000 ? timePerTurnMS/1000 : secondsLeft ) : 'Time\'s Up!' }}</span></p>
          <vs-progress :height="25" :percent="Math.round(secondsLeft / (timePerTurnMS / 1000) * 100)" color="primary"></vs-progress>
          <p class="">
            <div class="inline-block relative pr-6 pt-2 text-dark font-medium" v-for="(words,i) in peopleHaveToGuessWords">{{ words.text }}{{ words.correct ? '✅':''}}{{ words.spellingCorrect ? '🔤':''}}</div>
          </p>
          <vs-divider/>
          <div class="overflow-auto text-dark">
              <div class="float-left w-1/2 pr-4" v-if="Object.keys(currentWriteBoard).length > 0">
                  <div class="mb-4" v-for="(player, i) in Object.keys(currentWriteBoard)" v-if="currentWriteBoard[player].trim() !== ''">
                    <label class="vs-input--label block mt-3 text-dark font-bold">{{ playerUIDToNames[player] }}</label>
                    <span class="text-dark" style="max-width: 120px; word-break: break-word;">{{ currentWriteBoard[player] }}</span>
                  </div>
              </div>
          </div>
          <p class="text-sm mb-2 text-center" v-if="!(Object.keys(currentWriteBoard).length > 0)"><span class="relative text-2xl" style="top: 2px;" >🤫</span> Not your turn!</p>
        </div>
        <div v-if="guessersNeedToSayReady">
          <p class="text-center my-12 text-lg px-6"><p class="text-center text-dark my-8 text-lg px-6">When {{ playerUIDToNames[currentTurn.explainer.uid] }} selects "Go!" they will <span class="font-bold">see 5 words</span> and have <span class="font-bold">40 seconds</span> to describe them to <span v-for="(player,i) in guessersNeedToSayReady">{{ player.name }}{{ guessersNeedToSayReady.length > 1 ? ( i === guessersNeedToSayReady.length - 1  ? '' : ( i === guessersNeedToSayReady.length - 2 ? ' and ' : ', ')) : '' }}</span>!</p>
        </div>
      </div>


      <div v-if="peopleHaveToGuessWords && secondsLeft === false" class="text-center">
        <h2 class="mt-20 text-4xl">☝️</h2>
        <h2 class="mb-6 mt-4">Calculating Scores...</h2>
        <p class="mb-20 text-xl">➕🤓➗🤯➖🤔➕</p>
      </div>

      <div class="text-center">
        <!--
        :open-hover="gameState.turnNo !== 0  && !peopleHaveToGuessWords"
        :open="gameState.turnNo === 0 && !peopleHaveToGuessWords"
        -->
        <vs-collapse type="margin"  class="small block w-full mt-4">
          <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down" >
            <div slot="header">
              Rules
            </div>
            <div class="block text-center my-1 text-lg px-4 font-medium text-dark">
              Teams take turns. Each turn, a different team member gets <span class="font-bold">40 seconds</span> to describe the given <span class="font-bold">5 "taboo" words</span> to his/her teammates, without saying those words!
              <p class="my-4">
              The guessing team-members type their guesses into a textbox before TIME'S UP!</p>
              <p class="my-4"> Teams get one point for each correct guess, and one extra point for 100% spelling!
              </p>
              <p class="mt-4">Teams get only one point for each correct word, even if more than one players have guessed it correctly.</p>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>

        <div class="" v-if="!peopleHaveToGuessWords">
          <label class="vs-input--label">Score</label>
          <div class="mt-3" v-for="team in currentScores">
            <p class="float-right inline-block" v-if="team.place === false">{{ team.score }} Points</p>
            <p class="float-right inline-block text-dark text-lg" v-if="team.place !== false">{{ team.place === 0 ? '1st🏆' : getOrdinal(team.place) }}</p>
            <h4 class="mb-2">{{ team.name }}</h4>
            <vs-progress :height="20" :percent="Math.round((team.score / 40) * 100)" color="secondary"></vs-progress>
            <span v-for="player in team.players" class="inline-block pr-3 text-xs">{{ player.name }}</span>
            <vs-divider/>
          </div>
          <p class="text-center" v-if="teamsDone.length === 0">🏆 First team to get to 40 wins!</p>
        </div>
        <div v-if="amItheHost">
          <div v-if="currentTurn.actionRequired !== 'guess' && currentTurn.explainer.uid !== myUID">
          <vs-button v-if="!iWantToRemove" :key="btnsKey + '23f'" @click="() => {iWantToRemove = currentTurn.explainer}" type="flat" class="mt-4 font-normal w-full" icon-pack="feather" icon="icon-x-circle">Remove {{ currentTurn.explainer.name }} from game</vs-button>
          <div v-if="iWantToRemove && !removeError">
            <p class="text-xl font-medium text-center mt-10">Are you sure you want to remove {{ iWantToRemove.name }}? they won't be able to re-join this game.</p>
            <vs-button @click="() => {iWantToRemove = false}" type="border" class="mt-4 font-normal w-1/2 float-left" :key="btnsKey + '2c3f'" >Cancel</vs-button>
            <vs-button @click="removeFromGame($event)" class="mt-4 font-normal w-1/2 float-left" icon-pack="feather" icon="icon-x-circle" :key="btnsKey + '2rr3f'">Remove</vs-button>
            <vs-divider class="my-5"/>
          </div>
          <div v-if="removeError && !iWantToLeave">
            <p class="text-xl font-medium text-center mt-10">{{ removeError }}</p>
            <vs-button @click="() => {iWantToRemove = false; removeError = false}" type="border" class="mt-4 font-normal w-full" :key="btnsKey + '2c3f'" >Ok</vs-button>
          </div>
          </div>
        </div>
        <div>
          <div v-if="currentTurn.actionRequired !== 'guess'">
          <vs-button v-if="!iWantToLeave" @click="() => {iWantToLeave = true}" type="flat" class="mt-4 font-normal w-2/3" style="margin-left: 16.5%;" icon-pack="feather" icon="icon-corner-up-left">Leave Game</vs-button>
          <div v-if="iWantToLeave && !removeError">
            <p class="text-xl font-medium text-center mt-10">Are you sure you want to leave? You won't be able to re-join this game.</p>
            <vs-button @click="() => {iWantToLeave = false}" type="border" class="mt-4 font-normal w-1/2 float-left" >Cancel</vs-button>
            <vs-button @click="leaveGame($event)" class="mt-4 font-normal w-1/2 float-left" icon-pack="feather" icon="icon-corner-up-left">Leave Game</vs-button>
            <vs-divider class="my-5"/>
          </div>
          <div v-if="removeError && !iWantToRemove">
            <p class="text-xl font-medium text-center mt-10">{{ removeError }}</p>
            <vs-button @click="() => {iWantToLeave = false; removeError = false}" type="border" class="mt-4 font-normal w-full" :key="btnsKey + '2c3f'" >Ok</vs-button>
          </div>
          </div>
        </div>
    </div>
  </div>
</div>
</template>


<script>
//
//<br>💡{{ guessesAllowed - player.guesses.length }}</span>
//
//

import draggable from 'vuedraggable'

import {
  mapGetters
} from 'vuex'

import qrCode from 'qrcode'

import nosleep from 'nosleep.js'
import debounce from 'debounce'

import Vue from 'vue'

import {
  Validator
} from 'vee-validate'

const dict = {
  custom: {
    first_name: {
      required: 'Your first name is required to play!',
      max: 'Your first name can\'t be longer than 20 characters.'
    }
  }
}

/*import Paintable from 'vue-paintable';

Vue.use(Paintable, {
  // optional methods
  setItem(key, image) {
  //console.log(key)
  },
  // you also can use async
  getItem(key) {
    return localStorage.getItem(key);
  },
  removeItem(key) {
    localStorage.removeItem(key);
  }
});*/


Validator.localize('en', dict)


function fallbackCopyTextToClipboard (text) {
  const textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand('copy')
    const msg = successful ? 'successful' : 'unsuccessful'
  } catch (err) {}

  document.body.removeChild(textArea)
}

function copyTextToClipboard (text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
    return
  }
  navigator.clipboard.writeText(text).then(function () {}, function (err) {})
}

export default {
  data () {
    return {
      myNumber: '',
      iAmChoosingTeams: false,
      screenMessageLocal: false,
      copyText: 'Copy Link',
      btnsKey: 0,
      availablePlayers: [],
      copyIcon: 'icon-copy',
      imAJoinerName: '',
      showPlayButton: false,
      showQRPopup: false,
      iWantToLeave: false,
      myGuesses: '',
      showQRPopup: false,
      qrImgSrc: false,
      lastShowFollow: false,
      timerObj: '',
      removeError: false,
      iWantToRemove: false,
      secondsLeft: false,
      numPlayersNeeded: 4,
      hostChosenTeams: [
        {
          name: 'Team 1',
          players: []
        },
        {
          name: 'Team 2',
          players: []
        }
      ],
      showVoteButtonsLocal: true
    }
  },
  watch: {
    gameLink (v) {
      if (v) {
        if (!this.qrImgSrc) {
          this.generateQR()
        }
      }
    },
    gameStarted (v) {
      if (v) {
        this.scrollToTop()
        this.lastHostUIDLocal = v.hostUID
      }
    },
    gameState (v) {
      /*if (v.turnNo === 12 || v.turnNo === 30) {
          if (this.lastShowFollow !== v.turnNo) {
              this.$store.commit('SET_SHOW_FOLLOW')
              this.lastShowFollow = v.turnNo
          }
        }*/
      if (v.currentTurn.actionRequired === 'guess') {
        this.startTimer()
        this.myGuesses = ''
      }
    },
    myGuesses () {
      if (this.secondsLeft) {
        this.updateWriteBoard()
      }

    },
    secondsLeft (v) {
      if (v <= 0) {

        this.stopTimer()

        this.scrollToTop()

        let myTimeToSpeak = 0

        this.currentPlayersInSequence.forEach((pl, i) => {

          if (pl.uid === this.myUID) {
            myTimeToSpeak = i === 0 ? 1000 : (i * 2300)
          }

        })

        //console.log('my time to speak:')
        //console.log(myTimeToSpeak)

        this.sayTurnOverTO = setTimeout(() => {
          if (this.currentTurn.actionRequired === 'guess') {
            this.sayTurnIsOver()
          }
        }, myTimeToSpeak)

        this.secondsLeft = false

        if (this.myTeamsTurn && this.currentTurn.explainer.uid !== this.myUID) {
          this.updateWriteBoard()
        }
      }
    },
    timeLeftMS (value) {
      /*if (this.timeLeftMS !== 0) {
                        setTimeout(() => {


                            //timeLeftMS should be   (timeLaunchedMS + timePerTurnMS) - now.timeStampMS
                            let time = new Date()
                            let timeS = time.getSeconds()
                            let time = this.currentTurn.turnStarted + Math.floor(this.timePerTurnMS / 1000) - timeS
                            this.timeLeftMS = this.timeLeftMS - 1000;

                            //let hundredths= (this.timeLeftMS * 10).toFixed(0);

                            //if(hundredths.length < 2) hundredths= "0" + hundredths;

                            //let seconds = ((this.timeLeftMS % 60000) / 1000).toFixed(0);
                            //this.timeLeftString = seconds

                        }, 1000);
                  }*/
    },
    peopleHaveToGuessWords: {
      handler (v) {
      //console.log('people have to guess words')
        if (v) {

        //console.log('!!starting timer, people have to guess!!')
          if (Array.isArray(v)) {
            //this.startTimer()
            //this.myGuesses = ''
          }

        }
      },
      deep: true
    },
    hostChosenTeams: {
      handler () {
        if (this.availablePlayers.length !== this.playersVerifiedAtStart) {
          this.debounceTeamsUpdate()
        }
      },
      deep: true
    },
    playersVerifiedAtStart (v) {
      if (v && this.amItheHost) {

        v.forEach((pl) => {

          //for each player:
          let isAlreadyChosenOrAvailable = false

          this.availablePlayers.forEach((avpl) => {
            if (avpl.uid === pl.uid) {
              isAlreadyChosenOrAvailable = true
            }
          })

          this.hostChosenTeams.forEach((team) => {

            team.players.forEach((chosenpl) => {
              if (chosenpl.uid === pl.uid) {
                isAlreadyChosenOrAvailable = true
              }
            })
          })

          if (!isAlreadyChosenOrAvailable) {
            this.availablePlayers.push(pl)
          }

        })

      }
    },
    gameStarted (v) {

      if (v) {

        this.$store.dispatch('typeItOut/syncWriteboard')
      }

    },
    currentTurn (v) {
      /*
        if (typeof v.actionRequired !== "undefined") {
            if(v.actionRequired === 'allvote') {
                this.showVoteButtonsLocal = false
              //console.log('set timeout')

                setTimeout(() => {
                    this.showVoteButtonsLocal = true
                }, 5000)
            }
        } else {
            this.showVoteButtonsLocal = false
        }*/
    },
    screenMessage (v) {
    //console.log('sm changed:')
    //console.log(v)


      if (v) {
        if (v.context === 'leave') {
          if (this.currentTurn.actionRequired !== 'guess') {
            this.screenMessageLocal = v
          }
        } else {
          this.stopTimer()
          this.screenMessageLocal = v
        }

      } else {
        this.screenMessageLocal = false
      }
    }
  },
  computed: {
    teamsGoodToGo () {
      let good = true
      if (this.availablePlayers.length === 0 && this.amItheHost) {
        this.hostChosenTeams.forEach((team) => {
          if (team.players.length < 2) {
            good = false
          }
        })
      } else {
        good = false
      }
      return good
    },
    whatsAppLink () {
      if (this.gameID && this.gameLink) {
        return `whatsapp://send?text= Join my game of "Team Taboo" on Remote Social!: ${  this.gameLink}`
      }
      return false
    },
    ...mapGetters({
      guessersReady: 'typeItOut/guessersReady',
      teamsDone: 'typeItOut/teamsDone',
      timePerTurnMS: 'typeItOut/timePerTurnMS',
      currentScores: 'typeItOut/currentScores',
      myTeamIndex: 'typeItOut/myTeamIndex',
      teamsChosen: 'typeItOut/teamsChosen',
      teams: 'typeItOut/teams',
      currentTurn: 'typeItOut/currentTurn',
      isDrinkingGame: 'typeItOut/isDrinkingGame',
      screenMessage: 'typeItOut/screenMessage',
      currentPlayersInSequence: 'typeItOut/currentPlayersInSequence',
      gameLink: 'typeItOut/gameLink',
      amIVerified: 'typeItOut/amIVerified',
      gameStarted: 'typeItOut/gameStarted',
      gameOver: 'typeItOut/gameOver',
      myName: 'typeItOut/myName',
      nameOfHost: 'typeItOut/nameOfHost',
      myUID: 'typeItOut/myUID',
      playersVerifiedAtStart: 'typeItOut/playersVerifiedAtStart',
      gameID: 'typeItOut/gameID',
      gameState: 'typeItOut/currentGameState',
      amItheHost: 'typeItOut/amItheHost',
      playerUIDToNames: 'typeItOut/playerUIDToNames',
      peopleHaveToGuessWords: 'typeItOut/peopleHaveToGuessWords',
      guessersNeedToSayReady: 'typeItOut/guessersNeedToSayReady',
      myTeamsTurn: 'typeItOut/myTeamsTurn',
      currentWriteBoard: 'typeItOut/currentWriteBoard'
    })
  },
  components: {
    draggable
  },
  methods: {
    removeFromPUTN ($event, uid) {
      
      this.makeBtnLoading($event, 'Removing...')

      this.$store.dispatch('removePlayerFromGame', {
        gameType: 'teamtaboo',
        gameID: this.gameID,
        removeUID: uid
      }).then((result) => {
       
      }).catch((e) => {
        //console.log(e)
      })

    },
    myGuessesContainAnyOf (arr) {
      let contain = false
      arr.forEach((guess, i) => {
        if (this.myGuesses.trim().indexOf(guess) !== -1) contain = guess
      })
      return contain
    },
    generateQR () {
      const this2 = this
      //console.log(this.$refs.gameqr)
      //console.log(this.gameLink)
      qrCode.toCanvas(this.$refs.gameqr, this.gameLink, function (error) {
        if (error) console.error(error)
        //console.log('success!');
        //console.log(this2.$refs.gameqr.toDataURL())
        this2.qrImgSrc = this2.$refs.gameqr.toDataURL()
      })
    },
    leaveGame ($event) {
      const toRemove = this.myUID

      this.makeBtnLoading($event, 'Removing...')

      this.$store.dispatch('typeItOut/leaveSkipRemove', {
        uid: toRemove
      }).then((res) => {
        if (res.data.errorText === 'notmorethan2') {
          this.removeError = 'We can\'t remove you, because teams need to have at least two players.'
        } else {
          window.location = 'http://www.ziago.co'
        }
        this.btnsKey++
      })
    },
    removeFromGame ($event) {
      const toRemove = this.iWantToRemove.uid

      this.makeBtnLoading($event, 'Removing...')

      this.$store.dispatch('typeItOut/leaveSkipRemove', {
        uid: toRemove
      }).then((res) => {
        if (res.data.errorText === 'notmorethan2') {
          this.removeError = 'We can\'t remove that player, because teams need to have at least two players.'
        } else {
          this.iWantToRemove = false
          this.removeError = false
        }
        this.btnsKey++
      })


    },
    stopTimer () {
      clearTimeout(this.timerObj)
      this.timerObj = false
    },
    startTimer () {
      this.secondsLeft = (this.timePerTurnMS / 1000)

      const syncTime = () => {

        //let timeS = Math.floor(Date.now() / 1000)

        //this.secondsLeft = (this.currentTurn.turnStarted + Math.floor(this.timePerTurnMS / 1000)) - timeS

        this.timerObj = setTimeout(syncTime, 1000)

        this.secondsLeft = this.secondsLeft - 1


        //this.timerObj = setTimeout(syncTime, 1000)


      }
      if (!this.timerObj) { syncTime() }
    },
    sayTurnIsOver () {
      if (typeof this.currentTurn.actionRequired !== 'undefined') {
        if (this.currentTurn.actionRequired === 'guess') {
          //console.log('is still guess saying turn is over')
          this.$store.dispatch('typeItOut/sayTurnIsOver')
        }
      }
    },
    sayImReady ($event) {
      this.makeBtnLoading($event, 'Connecting...')
      this.$store.dispatch('typeItOut/sayImReady')
    },
    updateWriteBoard: debounce(function (val) {
      //console.log(val)
      this.$store.dispatch('typeItOut/updateWriteBoard', {
        myInput: this.myGuesses
      })
    }, 500),
    debounceTeamsUpdate: debounce(function (val) {
      //console.log(val)
      this.$store.dispatch('typeItOut/sendChosenTeams', {
        teams: this.hostChosenTeams
      })

    }, 500),
    playAgain ($event) {
    //console.log('saying play again')
      this.makeBtnLoading($event, 'Connecting...')
      this.$store.dispatch('typeItOut/startGame', {
        resetGame: true
      }).then((result) => {
        this.scrollToTop()
      //console.log(result)
      }).catch((e) => {
      //console.log(e)
      })
    },
    getOrdinal (n) {
      let s = ['th', 'st', 'nd', 'rd'],
        v = n % 100
      return n + (s[(v - 20) % 10] || s[v] || s[0])
    },
    makeBtnLoading ($event, text) {

      const btnText = typeof text !== 'undefined' ? text : 'Connecting to players...'

      //console.log($event)
      const srcEl = $event.srcElement
      srcEl.innerHTML = btnText
      srcEl.setAttribute('disabled', 'true')
    },
    copyLink () {
      this.copyText = 'Copied!'
      this.copyIcon = false
      copyTextToClipboard(this.gameLink)
    },
    vote ($event, who) {

      this.makeBtnLoading($event, 'Voting...')

      this.$store.dispatch('typeItOut/vote', {
        who
      }).then((res) => {
      //console.log(res)

      }).catch((e) => {
      //console.log(e)

      })
    },
    startGame ($event) {

      const noSleep = new nosleep()
      noSleep.enable()
      this.scrollToTop()

      this.makeBtnLoading($event)
      this.$store.dispatch('typeItOut/startGame', {
        resetGame: false,
        teams: this.hostChosenTeams
      }).then((result) => {
      //console.log(result)
      }).catch((e) => {
      //console.log(e)
      })
    },

    verifyMe ($event) {
      this.$validator.validateAll().then(result => {
        if (result) {

          //check all RS parameters are present
          let allParamsOk = true
          if (typeof this.$route.query.uid === 'undefined' || typeof this.$route.query.accountId === 'undefined') allParamsOk = false
          if (!allParamsOk) {
            this.$vs.notify({
              title: 'Oops!',
              text: 'Something went wrong with joining this game. Taking you back to Remote Social...',
              time: 60000
            })
            setTimeout(() => {
              window.location.href = 'https://hub.remotesocial.io'
            }, 5000)
            return
          }
          //checks done

          const noSleep = new nosleep()
          noSleep.enable()

          this.$vs.loading()

          //call the FB function to add me to the game here
          this.$store.dispatch('typeItOut/verifyMyName', {
            nameProvided: this.imAJoinerName,
            gameID: this.gameID,
            rsUID: decodeURIComponent(this.$route.query.uid),
            rsAccountID: decodeURIComponent(this.$route.query.accountId)
          }).then((result) => {
            this.scrollToTop()
            this.$vs.loading.close()

            //console.log(result)

            if (result.data.verified) {
              /*console.log('verified, sying that Im online')
              this.$store.dispatch('typeItOut/startIAmOnline', {
                gameID: this.gameID
              })
              this.$store.dispatch('typeItOut/startCheckingWhosOnline')*/
            } else {
            //console.log('I wasnt invited?')
              this.$vs.loading.close()
            }
            //do something
          }).catch((e) => {
          //console.log(e)
          })

        }
      })
    }
  },
  mounted () {
    if (this.gameLink) {
      this.generateQR()
    }
  },
  created () {

    if (typeof this.$route.query.displayName !== 'undefined') {
      this.imAJoinerName = decodeURIComponent(this.$route.query.displayName)
    }

    this.screenMessageLocal = false
    const thisRoute = this.$route
    //check if game was just created by me, else it's a fresh load
    if (this.$store.state.typeItOut.gameID) {
    //console.log('host created, connection already made')
      /*this.$store.dispatch('typeItOut/startIAmOnline', {
        gameID: this.gameID
      })
      this.$store.dispatch('typeItOut/startCheckingWhosOnline')*/
      this.$vs.loading.close()
    } else {
      this.$vs.loading()
      //this is someone joining, or someone refreshing
      //console.log('loggin in')
      this.$store.dispatch('auth/registerUserAnonymous').then(() => {
        //look for game
        const gameID = thisRoute.query.gameId ? thisRoute.query.gameId : false
        //sync state
        if (!gameID) {
          window.location.href = 'https://hub.remotesocial.io'
        } else {
          this.$store.dispatch('typeItOut/syncState', {
            docID: gameID
          }).then(() => {
          //console.log('game ready to go, now need to verify')
            this.$vs.loading.close()
          }).catch((e) => {
            //bad game ID, reroute to 'this game doesn't exist page'
            window.location.reload()
          //console.log(e)
          })
        }
      }).catch((e) => {
      //console.log(e)
      })
    }
  }
}
</script>

<style lang="scss">

body {
  position: static !important;
}

.paintable {
  position: static !important;
  overflow: visible;
}

.login-tabs-container {
    min-height: 505px;

    .con-tab {
        padding-bottom: 14px;
    }

    .con-slot-tabs {
        margin-top: 1rem;
    }
}

div.font-medium_pt {
  color: #A1A1A1 !important;
}

div.text-light_pt {
  font-weight: 500 !important;
}

</style>
